export const DISPLAY_COPIES = {
    golive: {
        title: 'Live the Model',
        description: 'Are you sure you want to make this product live? This action cannot be undone.',
        okButtonText: 'Proceed',
        cancelButtonText: 'Cancel'
    },
    reset: {
        title: 'Reset the Data',
        description: 'Are you sure you want to reset the data? This action cannot be undone.',
        okButtonText: 'Reset',
        cancelButtonText: 'Cancel'
    }
};

export const FSNS_ACTION = {
    GO_LIVE: 'golive',
    RESET: 'reset'
};

export const ArInfoOptions = [
    {
        label: 'Select an option',
        value: '',
        meta: {
            enable3DinPP: {
                value: false,
                disabled: false,
                hidden: true
            },
            enableSizeCompare: {
                value: false,
                disabled: false,
                hidden: true
            },
            enableFitInThreeDExperienceOnPP: {
                value: false,
                disabled: false,
                hidden: true
            },
            enableDimension: {
                value: false,
                disabled: false,
                hidden: true
            },
            enableLiteMobileHotspot: {
                value: false,
                disabled: false,
                hidden: true
            }
        }
    },
    {
        label: '3d-only',
        value: '3d-only',
        meta: {
            enable3DinPP: {
                value: false,
                disabled: false,
                hidden: false
            },
            enableSizeCompare: {
                value: false,
                disabled: false,
                hidden: false
            },
            enableFitInThreeDExperienceOnPP: {
                value: false,
                disabled: false,
                hidden: false
            },
            enableDimension: {
                value: false,
                disabled: false,
                hidden: false
            },
            enableLiteMobileHotspot: {
                value: false,
                disabled: false,
                hidden: false
            }
        }
    },
    {
        label: 'ar-only',
        value: 'new-native-ar',
        meta: {
            enable3DinPP: {
                value: false,
                disabled: false,
                hidden: true
            },
            enableSizeCompare: {
                value: false,
                disabled: false,
                hidden: true
            },
            enableFitInThreeDExperienceOnPP: {
                value: false,
                disabled: false,
                hidden: true
            },
            enableDimension: {
                value: false,
                disabled: false,
                hidden: true
            },
            enableLiteMobileHotspot: {
                value: false,
                disabled: false,
                hidden: true
            }
        }
    },
    {
        label: '3d-ar',
        value: 'new-native-ar',
        meta: {
            enable3DinPP: {
                value: false,
                disabled: false,
                hidden: false
            },
            enableSizeCompare: {
                value: false,
                disabled: false,
                hidden: false
            },
            enableFitInThreeDExperienceOnPP: {
                value: false,
                disabled: false,
                hidden: false
            },
            enableDimension: {
                value: false,
                disabled: false,
                hidden: false
            },
            enableLiteMobileHotspot: {
                value: false,
                disabled: false,
                hidden: false
            }
        }
    },
    {
        label: 'disable-experience',
        value: 'disable-experience',
        meta: {
            enable3DinPP: {
                value: false,
                disabled: false,
                hidden: true
            },
            enableSizeCompare: {
                value: false,
                disabled: false,
                hidden: true
            },
            enableFitInThreeDExperienceOnPP: {
                value: false,
                disabled: false,
                hidden: true
            },
            enableDimension: {
                value: false,
                disabled: false,
                hidden: true
            },
            enableLiteMobileHotspot: {
                value: false,
                disabled: false,
                hidden: true
            }
        }
    },
    {
        label: 'fit-in-3d',
        value: 'fit-in-3d',
        meta: {
            enable3DinPP: {
                value: true,
                disabled: true,
                hidden: false
            },
            enableSizeCompare: {
                value: false,
                disabled: false,
                hidden: false
            },
            enableFitInThreeDExperienceOnPP: {
                value: false,
                disabled: false,
                hidden: false
            },
            enableDimension: {
                value: false,
                disabled: false,
                hidden: false
            },
            enableLiteMobileHotspot: {
                value: false,
                disabled: false,
                hidden: false
            }
        }
    }
];
